exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".info-box{padding:1%}.log-in-well{border:1px solid #bbb;box-shadow:0 0 20px rgba(0,0,0,.5);padding:3%}.auth-container{margin:5%}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/routes/PageNotFound/components/src/routes/PageNotFound/components/style.scss"],"names":[],"mappings":"AAAA,UACI,UAAW,CACd,AACD,aACI,sBAAsB,AACtB,mCAA2C,AAC3C,UAAW,CACd,AACD,gBACI,SAAU,CACb","file":"style.scss","sourcesContent":[".info-box{\n    padding: 1%;\n}\n.log-in-well {\n    border: 1px solid #bbb;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);\n    padding: 3%;\n}\n.auth-container{\n    margin: 5%;\n}"],"sourceRoot":""}]);

// exports
